import React from 'react';
import { Button } from '@mui/material';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { buildContactMailto } from '../../brand/config';
import { useI18n } from '../../i18n';

/**
 * @param {{ variant?: 'contained' | 'outlined' | 'text', size?: 'small' | 'medium' | 'large', fullWidth?: boolean, showIcon?: boolean, labelKey?: string }} props
 */
export default function ContactInquiryButton({
  variant = 'outlined',
  size = 'medium',
  fullWidth = false,
  showIcon = true,
  labelKey = 'contact.cta',
}) {
  const { t, locale } = useI18n();
  const href = buildContactMailto({ locale });

  return (
    <Button
      component="a"
      href={href}
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      startIcon={showIcon ? <EmailOutlinedIcon /> : undefined}
      sx={{ borderRadius: 2, fontWeight: 600 }}
      data-testid="contact-inquiry"
    >
      {t(labelKey)}
    </Button>
  );
}
